// Welcome.js

import React from "react";
import { translations } from "../translations";

const Welcome = ({ language }) => {
  const lang = translations[language];

  return (
    <div className="flex flex-col items-center justify-center h-full p-1 px-2 text-balance">
      <img
        src="https://cbimagesicons.blob.core.windows.net/chat-icons/fb-logo-removebg-preview.png"
        alt="Welcome"
        className="w-39 h-24 mb-5" //w-26.25 h-16 mb-5f
      />
      <div className="text-center">
        <h1
          style={{
            fontWeight: "bold",
          }}
          className="text-xl font-semibold mb-2"
        >
          {lang.welcome}
        </h1>
        <p className="text-l">{lang.askQuestions}</p>
        <p className="text-m">{lang.discover}</p>
      </div>
    </div>
  );
};

export default Welcome;
